import { sanitizeTabulatorLayoutAttributes } from "./tabulatorProgressiveLoading";

/**
 * Získa z Tabulator inštancie aktuálny stav pre štandardnú masku:
 * columns = { field: true/false } (visibility), attributes = getColumnLayout() (order + widths).
 * Používa sa pri "Nastaviť ako štandardnú masku" – bez dialógu, priamo z tabuľky.
 *
 * @param {object} table - Tabulator inštancia (getTable())
 * @returns {{ columns: object, attributes: array } | null}
 */
export function getTabulatorLayoutForStandardMask(table) {
  if (!table) return null;
  try {
    const columns = {};
    const colList = table.getColumns?.() ?? [];
    for (let i = 0; i < colList.length; i++) {
      const col = colList[i];
      const field = col.getField?.() ?? col.getDefinition?.()?.field;
      if (field != null) {
        const visible = col.getVisible?.() ?? col.isVisible?.();
        columns[field] = visible !== false;
      }
    }
    const attributes = table.getColumnLayout?.() ?? null;
    return { columns, attributes: sanitizeTabulatorLayoutAttributes(attributes) };
  } catch (_) {
    return null;
  }
}
